import { ImportPortefeuilleDetail } from "./../../../../../../models/ImportPortefeuilleDetail";
import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-credit",
  templateUrl: "./credit.component.html",
  styleUrls: ["./credit.component.scss"],
})
export class CreditComponent implements OnInit {
  @Input()
  portefeuilleDetail: ImportPortefeuilleDetail;

  constructor() {}

  ngOnInit() {}
}
